import {browserTracingIntegration} from '@sentry/browser';
import {init} from '@sentry/react';

import {getWorkspaceFromUri} from './getWorkspaceFromUri';

/**
 * Errors that are never actionable for this application.
 *
 * Client connectivity ("Failed to fetch" in Chromium, "Load failed" in WebKit) is a
 * property of the visitor's network, not of the certificate app, and it dominated the
 * project's event volume. Everything else here originates in browser extensions or in
 * the host WebView of an in-app browser, outside our bundle.
 *
 * Ambiguous errors are deliberately NOT listed - an error that could come from our own
 * code must keep reporting even when it looks like third-party noise.
 */
const IGNORED_ERRORS = [
  /network error/i,
  /failed to fetch/i,
  /load failed/i,
  /invalid call to runtime\.sendMessage/i,
  /error invoking postMessage/i,
];

/** Frames injected by browser extensions rather than served by us. */
const DENIED_URLS = [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-web-extension:\/\//];

export function sentryInit() {
  const {workspace} = getWorkspaceFromUri();

  init({
    dsn: process.env.SENTRY_DSN,
    tracesSampleRate: 1.0,
    debug: false,
    enabled: process.env.ENV_TYPE === 'prod',
    environment: process.env.ENV_TYPE,
    initialScope: {
      tags: {workspace},
    },
    integrations: [browserTracingIntegration()],
    release: process.env.COMMIT_HASH,
    normalizeDepth: 10,
    normalizeMaxBreadth: 10,
    ignoreErrors: IGNORED_ERRORS,
    denyUrls: DENIED_URLS,
  });
}
